(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/store/game-guide-slice.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/store/game-guide-slice.js');
"use strict";

var _svs$arena;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

const logger = svs.arena.logger;
const {
  getCmsDataFolderAsync
} = svs.arena.service.gameGuideService;
const gameGuideArticleFolder = ((_svs$arena = svs.arena) === null || _svs$arena === void 0 || (_svs$arena = _svs$arena.data) === null || _svs$arena === void 0 || (_svs$arena = _svs$arena.config) === null || _svs$arena === void 0 ? void 0 : _svs$arena.gameGuideArticleFolder) || '';
const fetchGameGuideArticles = RTK.createAsyncThunk('arena/fetchgameguidearticles', async (_, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    var _response$data, _response$data2;
    svs.arena.logger.debug('fetchGameGuideArticles, start');
    const response = await getCmsDataFolderAsync(gameGuideArticleFolder);
    svs.arena.logger.debug('fetchGameGuideArticles, response: ', response);
    if (!response || response !== null && response !== void 0 && response.error) {
      return rejectWithValue({
        error: response.error.code
      });
    }
    return {
      status: 'success',
      error: null,
      dataOrg: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.result.slice(),
      data: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.result
    };
  } catch (error) {
    svs.arena.logger.debug('fetchGameGuideArticles, error: ', error);
    return rejectWithValue({
      error
    });
  }
});

const getInitialState = () => ({
  articles: []
});
const gameGuideSlice = RTK.createSlice({
  name: 'gameguide',
  initialState: getInitialState(),
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchGameGuideArticles.fulfilled, (state, action) => {
      logger.debug('fetchGameGuideArticles.fulfilled, action: ', action);
      state.articles = action.payload.data;
    }).addCase(fetchGameGuideArticles.rejected, state => {
      logger.debug('fetchGameGuideArticles.rejected, state: ', state);
    });
  }
});
svs.arena.store.gameguide = svs.arena.store.gameguide || {};
svs.arena.store.gameguide.actions = _objectSpread({
  fetchGameGuideArticles
}, gameGuideSlice.actions);
svs.arena.store.gameguide.reducer = gameGuideSlice.reducer;
svs.arena.store.gameguide.initialState = getInitialState();

 })(window);